<template>
  <v-dialog v-model="dialog" persistent width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        dark
        v-bind="attrs"
        v-on="on"
        :disabled="!$permission('128')"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dense>
        <v-toolbar-title>
          {{ $t("editWebhook") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-form v-model="form.valid" class="pa-4" @submit.prevent="saveEdit">
        <v-card-text>
          <v-text-field
            v-model="form.url"
            label="URL"
            placeholder="https://suaapi.com/v2/endpoint"
            required
            type="url"
            solo-inverted
            dense
            :rules="[rules.required, validUrl]"
            :disabled="!$permission('128')"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pt-4 px-4 mt-6 ">
          <v-spacer />
          <v-btn
            color="primary"
            @click="saveEdit"
            :loading="loading"
            :disabled="!form.valid || disableButton || loading"
          >
            {{ $t("toSave") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { validate } from "@/util/validate.js";

export default {
  props: {
    infos: {
      endpoint: { type: String },
      webhookId: { type: String },
    },
  },

  data: (self) => ({
    refresh: false,
    dialog: false,
    statusItems: [
      {
        text: self.$t("active"),
        value: "Ativo",
      },
      {
        text: self.$t("inactive"),
        value: "Inativo",
      },
    ],

    form: {
      valid: false,
      url: "",
    },

    rules: {
      required: validate.required,
    },

    loading: false,
  }),

  created() {
    this.form.url = this.infos.endpoint;
  },

  watch: {
    dialog(val) {
      if (val) {
        this.form.url = this.infos.endpoint;
      }
    },
  },

  computed: {
    disableButton() {
      if (this.form.url === this.infos.endpoint) {
        return true;
      }

      return false;
    },
  },

  methods: {
    saveEdit() {
      if (!this.form.valid || this.disableButton || this.loading) {
        return;
      }

      this.loading = true;

      this.$axios
        .post(
          `${this.$prefix()}/WebHook/editWebhook`,
          this.$formdata({
            id: this.infos.webhookId,
            endpoint: this.form.url,
          })
        )
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });

          this.dialog = false;

          this.$emit("refresh");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    validUrl(str) {
      const pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR IP (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$", // fragment locator
        "i"
      );

      return pattern.test(str) || this.$t("urlNo");
    },
  },
};
</script>
